import { PropertyNode } from "@/shared/template-properties/model/types";

export function arrayToTree(arr: string[]): PropertyNode[] {
  const result: PropertyNode[] = [];

  for (const property of arr) {
    const parts = property.split(".");

    let parent = result;
    let key = "";

    for (const part of parts) {
      key = key ? [key, part].join(".") : part;

      const existNode = parent.find((node) => node.key === key);

      if (existNode) {
        existNode.isLeaf = false;
        parent = existNode.children;
      } else {
        const newNode = {
          key,
          title: part,
          property: property === key ? property : null,
          isLeaf: true,
          children: [],
        };
        parent.push(newNode);
        parent = newNode.children;
      }
    }
  }

  return result;
}
